<template>
  <v-list-item class="transaction">
    <span>
      <p class="mt-2 mb-0">
        <v-chip>{{ transaction.type }}</v-chip>
        <v-chip>{{ transaction.method }}</v-chip>
        <v-chip>{{ transaction.info }}</v-chip>
        <v-chip>{{ transaction.created_at.substr(0, 16) }}</v-chip>
      </p>
      <p class="ma-2"><strong>{{ transaction.type === "cash-in" ? "Sent" : "Received" }} {{ Math.abs(transaction.amount_action || 0) }} {{ transaction.currency_action }} -- {{ transaction.type === "cash-in" ? "Received" : "Sent" }} {{ Math.abs(transaction.amount || 0) }} {{ transaction.currency }}</strong></p>
    </span>
  </v-list-item>
</template>

<script>
export default {
  name: "Transaction",
  props: ["transaction"],
}
</script>

<style scoped>
  .transaction {
    background-color: #4c4c4c;
    border-radius: 26px;
    border: 1px solid black;
  }
</style>
